import { ColorOptions, required } from '@jfs/ui-new'
import { pages, tooltipConfig } from '../../../../../src/util/util'
import {
  emailAndSftpFileTransferSchemaValidation,
  fileTransferSchemaValidation,
  sftpFileTransferSchemaValidation,
} from '../../../../../src/util/validations'
import { EmailAndSftpFileTransferModeComponent } from './FileTransferData/EmailAndSftpFileTransferMode'
import { FileTransferModeComponent } from './FileTransferData/EmailFileTransferMode'
import { SFTPFileTransferModeComponent } from './FileTransferData/SftpFileTransferMode'
import { FileTranferTextInput, InfoDropdown } from './InfoDropDown'
import { FileTransferData, FrequencyData, ReportFormat } from './ReportFrequency'
import { DownloadSample } from './ReportingFormat'
import { ReportValidityDatePicker } from './ReportValidityDatePicker'

export const textinputStyle = {
  //type: 'body12',
  labelPaddingBottom: 8,
  labelFontFamily: 'jiotype-medium',
  fontFamily: 'jiotype-medium',
  labelColor: '#202F4D8A' as ColorOptions,
  labelFontSize: 12,
  fontSize: 12,
  selectionColor: 'BLUE',
  placeholderTextColor: 'LIGHT_GREY_INTRO' as ColorOptions,
  color: 'BLACK_21',
  borderWidth: 1,
  borderColor: '#B9CBF0' as ColorOptions,
  borderRadius: 4,
  paddingVertical: 8,
  paddingHorizontal: 8,
}

export const addNewSettlementReportForm: any = (
  handleDownloadSample: any,
  reportExtensions: any,
  setReportExtensions: any,
  sUpdate: boolean = false,
  isNewPassword: boolean,
  setIsNewPassword: any,
  setFileTransferMode: any,
  fileTransferMode: any,
) => [
  {
    actionTitle: 'Submit',
    key: 'reportDetails',
    verticalSpacing: 10,
    formItems: [
      // {
      //   fieldName: 'reportConfigTitle',
      //   ComponentName: TextInputNew,
      //   label: 'Report Configuration Title',
      //   placeholder: 'Enter Report Title here',
      //   editable: true,
      //   validationSchema: required,
      //   marginHorizontal: 10,
      //   ...textinputStyle,
      //   type: 'body12',
      // },
      {
        fieldName: 'reportConfigTitle',
        ComponentName: FileTranferTextInput,
        title: 'Report Configuration Title',
        placeHolder: 'Enter Report Title here',
        editable: true,
        validationSchema: required,
        marginHorizontal: 10,
        maxLength: 150,
        tooltipInfo: tooltipConfig.configurationTitleInfo,
        ...textinputStyle,
        paddingBottom: 0,
        paddingTop: 0,
        marginLeft: 0,
        marginRight: 0,
        paddingLeft: 15,
      },
      {
        horizontalComps: [
          {
            fieldName: 'reportFormat',
            ComponentName: InfoDropdown,
            title: 'Report Format',
            label: 'Report Format',
            placeHolder: 'Select Settlement Report Format',
            validationSchema: required,
            //onValueChange: setReportExtensions,
            data: ReportFormat,
            testID: 'reportFormat',
            tooltipInfo: tooltipConfig.reportTypeInfo,
            top: -60,
          },
          {
            fieldName: 'reportExt',
            ComponentName: InfoDropdown,
            title: 'Report Extension',
            label: 'Report Extension',
            placeHolder: 'Select Report Extension',
            validationSchema: required,
            data: reportExtensions,
            testID: 'reportExt',
            tooltipInfo: tooltipConfig.reportExtInfo,
            top: -20,
          },
          {
            fieldName: 'downloadSample',
            ComponentName: DownloadSample,
            handleDownloadSample: handleDownloadSample,
          },
        ],
        horizontalFlex: 1,
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'reportFrequency',
            ComponentName: InfoDropdown,
            title: 'Report Frequency',
            label: 'Report Frequency',
            placeHolder: 'Select Report Frequency',
            validationSchema: required,
            data: FrequencyData,
            testID: 'reportFrequency',
            tooltipInfo: tooltipConfig.reportFrequencyInfo,
          },
          {
            fieldName: 'reportValidity',
            ComponentName: ReportValidityDatePicker,
            label: 'Configuration validity',
            placeholder: 'Select Validity Date',
            validationSchema: required,
            disabled: false,
            testID: 'reportValidity',
            tooltipInfo: tooltipConfig.reportValidityInfo,
            top: -60,
          },
          {
            fieldName: 'fileTransferMode',
            ComponentName: InfoDropdown,
            title: 'File Transfer Mode',
            label: 'File Transfer Mode',
            placeHolder: 'Select File Transfer Mode',
            validationSchema: required,
            data: FileTransferData,
            testID: 'fileTransferMode',
            tooltipInfo: tooltipConfig.fileTransferModeInfo,
            onValueChange: setFileTransferMode,
            top: -35,
          },
        ],
        horizontalFlex: 1,
        horizontalSpacing: 8,
      },
      // {
      //   horizontalComps: [
      //     {
      //       fieldName: 'reportType',
      //       ComponentName: InfoDropdown,
      //       title: 'Report Type',
      //       label: 'Report Type',
      //       placeHolder: 'Select Report Type',
      //       validationSchema: required,
      //       data: ReportTypes,
      //       testID: 'reportValidity',
      //       style: textinputStyle,
      //     },
      //   ],
      //   horizontalFlex: 1,
      //   horizontalSpacing: 8,
      // },
      {
        horizontalComps: [
          {
            fieldName: 'emailFileTransferConfig',
            label: 'Email Configuration',
            ComponentName: FileTransferModeComponent,
            validationSchema: fileTransferSchemaValidation,
            dependency: ['fileTransferMode', 'EMAIL'],
            editable: true,
            config: {
              recipients: pages.create_config.email_recipients,
            },
            sUpdate: sUpdate,
            sNewPassword: isNewPassword,
            setIsNewPassword: setIsNewPassword,
            ...textinputStyle,
          },
          {
            fieldName: 'sftpFileTransferConfig',
            label: 'SFTP Configuration',
            ComponentName: SFTPFileTransferModeComponent,
            validationSchema: sftpFileTransferSchemaValidation,
            dependency: ['fileTransferMode', 'SFTP'],
            editable: true,
            config: {
              recipients: pages.create_config.notification_recipients,
            },
            sUpdate: sUpdate,
            sNewPassword: isNewPassword,
            setIsNewPassword: setIsNewPassword,
            ...textinputStyle,
          },
          {
            fieldName: 'emailAndSftpFileTransferConfig',
            label: 'Email Configuration',
            ComponentName: EmailAndSftpFileTransferModeComponent,
            validationSchema: emailAndSftpFileTransferSchemaValidation,
            dependency: ['fileTransferMode', 'SFTP & EMAIL'],
            editable: true,
            config: {
              recipients: pages.create_config.notification_recipients,
            },
            sUpdate: sUpdate,
            sNewPassword: isNewPassword,
            setIsNewPassword: setIsNewPassword,
            ...textinputStyle,
          },
        ],
        horizontalFlex: 2,
        horizontalSpacing: 8,
      },
    ],
    horizontalFlex: 1,
    onSubmit: async () => {
      return ''
    },
  },
]
